var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"color":_vm.backgroundColor,"dismissible":_vm.dismissible,"transition":_vm.transition},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"dark":_vm.iconDarkTheme}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23f0b7e4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoteAlert.vue
// module id = 143
// module chunks = 1